<template>
  <div id="app">
    <div class="performance-bar">
      <span>FPS: {{ fps }}</span>
      <span>PING: {{ ping }}ms</span>
      <span>CPU: {{ cpuUsage }}%</span>
      <span>MEM: {{ memoryInfo.usage }}%</span>
    </div>
    <router-view></router-view>
  </div>
</template>

<script setup>
import { onUnmounted, ref } from 'vue';
import { useFps } from '@/utils/useFps';
import { useSystemInfo } from '@/utils/useSystemInfo';
import { measureLatency } from "netlytics";

// FPS 监测
const { fps, stop } = useFps({ every: 5 });

// 系统信息监测
const { cpuUsage, memoryInfo } = useSystemInfo({ interval: 1000 });

// Ping 监测
const ping = ref(null);
const loading = ref(false);
const pingTimer = ref(null);

const getLatency = async () => {
  loading.value = true;
  try {
    const PING = await measureLatency('https://zzf-gitch.github.io/wzry/#/Login');
    ping.value = Math.round(PING);
  } catch (error) {
    console.error('测量延迟失败:', error);
  } finally {
    loading.value = false;
  }
};

getLatency()

pingTimer.value = setInterval(getLatency, 5000);

onUnmounted(() => {
  stop();
  if (pingTimer.value) {
    clearInterval(pingTimer.value);
    pingTimer = null;
  }
});
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

body,
html {
  width: 100%;
  height: 100%;
  /* // background-image: url(assets/wappler.jpg); */
  /* // background-repeat: no-repeat; */
  /* // background-size: 100% 100%; */
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* // text-align: center; */
  color: #2c3e50;
  height: 100%;
  margin: 0;
  padding: 0;
}

#nprogress {
  pointer-events: none;
}

#nprogress .bar {
  background-image: linear-gradient(45deg, #30cfd0 0%, #330867 100%);
  opacity: 0.75;
  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
}

.performance-bar {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: #0f0;
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 4px;
  z-index: 9999;
  display: flex;
  gap: 20px;
  font-weight: bold;
  font-family: Arial, sans-serif;
  font-size: 16px;
}
</style>